<template>
  <div>
    <label style="display: flex; position: relative; align-items: center">
      <vs-input class="w-full h-full" style="border-radius: 5px" :value="targetCat === 'cat3' ? (selectCatDataOld ? selectCatDataOld.cat3 : '') : selectCat" :readonly="readonly" @click="handleClickInput" />
    </label>

    <vs-popup class="popupSearchField" :title="popupTitle" :active.sync="showPopup">
      <!-- =========================== SEARCH =========================== -->
      <vs-row class="pb-2 text-center" style="border-bottom: 1px solid #e0e0e0">
        <vs-col class="w-10/12 flex" vs-align="center">
          <vs-col class="w-4/12 flex" vs-align="center">
            <span class="w-4/12">검색어</span>
            <ml-input class="w-8/12" v-model="page.keyword" @keyup.enter="handleClickSearch" />
          </vs-col>
        </vs-col>
        <vs-col class="w-2/12 text-right">
          <vs-button color="secondary" @click="handleClickSearch">검색</vs-button>
        </vs-col>
      </vs-row>
      <!-- =========================== CONTENT =========================== -->
      <vs-row>
        <vs-col>
          <vs-table stripe :sst="true" :max-items="page.perPage" :data="catList" noDataText="데이터가 없습니다">
            <template slot="thead">
              <vs-th style="width: 100px"><span class="w-full h-full">No.</span></vs-th>
              <vs-th><span class="w-full h-full">라벨</span></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                v-for="(cat, index) in data"
                :key="index"
                :class="selectCatData && (targetCat === 'cat3' ? selectCatData.id === cat.id : selectCatData[targetCat] === cat[targetCat]) ? 'active' : ''"
                class="cursor-pointer"
                @click.native="() => handleItemClickDetail(cat)"
              >
                <vs-td>{{ page.perPage * (page.current - 1) + index + 1 }}</vs-td>
                <vs-td>{{ cat[targetCat] }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>

          <div class="vs-con-table">
            <div class="con-pagination-table vs-table--pagination">
              <k-pagination :total="page.lastPage ? page.lastPage : 0" v-model="page.current" @change="handleChangePage"></k-pagination>
            </div>
          </div>
        </vs-col>

        <vs-col class="mt-4 flex" vs-align="center" vs-justify="flex-end">
          <vs-button class="mr-4" color="#EDEDED" text-color="black" type="filled" @click="handleClickClose">닫기 </vs-button>
          <vs-button color="secondary" @click="handleClickSelect">선택</vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import KPagination from "@/components/kPagination/kPagination";
import HttpRequest from "@/util/HttpRequest";

export default {
  name: "CategorySelector",
  components: {
    KPagination,
  },
  props: {
    readonly: Boolean,
    popupTitle: {
      type: String,
      default: "카테고리 검색",
    },
    targetCat: {
      type: String,
      default: "cat1",
    },
    // CAT1, CAT2 => STRING
    // CAT3 => NUMBER(id)
    value: {
      type: [Number, String, null],
      default: null,
    },
  },
  computed: {
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
  },
  data() {
    return {
      showPopup: false,
      selectCat: this.value,
      selectCatData: null,
      selectCatDataOld: null,

      // TABLE
      page: {
        keyword: "",

        current: 1,
        lastPage: 1,
        perPage: 10,
      },

      catList: [],
    };
  },
  async created() {
    if (this.value) {
      const setCat = await HttpRequest.get(`/api/v1/field/facility-category/detail`, { params: { id: this.value } });
      this.selectCatDataOld = setCat;
    }
  },
  methods: {
    handleClickInput() {
      if (this.readonly) return;

      this.selectCatData = this.selectCatDataOld;
      this.showPopup = true;
    },

    async loadCatList() {
      const params = {
        page: this.page.current,
        perPage: this.page.perPage,
        keyword: this.page.keyword,
      };
      const loadCat = await HttpRequest.get(`/api/v1/field/facility-category/${this.targetCat}`, { params });
      this.catList = loadCat.data.filter((cat) => !!cat[this.targetCat]);
      this.page.lastPage = loadCat.last_page;
    },

    handleClickSearch() {
      this.loadCatList();
    },

    handleChangePage() {
      this.loadCatList();
    },

    handleItemClickDetail(data) {
      if (this.selectCatData === data) this.selectCatData = null;
      else this.selectCatData = data;
    },
    handleClickSelect() {
      if (this.targetCat === "cat3") this.selectCat = this.selectCatData.id;
      else this.selectCat = this.selectCatData[this.targetCat];

      this.selectCatDataOld = this.selectCatData;

      this.$emit("input", this.selectCat);
      this.$emit("select", this.selectCatData);

      this.handleClickClose();
    },
    handleClickClose() {
      this.showPopup = false;
    },
  },
};
</script>

<style scoped>
.vs-con-table.stripe .tr-values.active {
  background: rgb(102, 112, 203) !important;
  color: #fff;
  font-width: bold;
}

th,
td {
  text-align: center !important;
}
th .vs-table-text {
  justify-content: center;
}
.textCenter {
  text-align: center;
}
</style>
